import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  ControlContainer,
  FormGroup,
  FormControl,
  FormBuilder,
  FormArray,
  Validators,
} from "@angular/forms";
import { ModaleRicercaAvanzataAnagrafeComponent } from "../modale-ricerca-avanzata-anagrafe/modale-ricerca-avanzata-anagrafe.component";
import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { EntitaAnagrafeVO } from "@app/shared/vo/gescor/entita-anagrafeVO";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { DestinatarioVO } from "@app/shared/vo/gescor/destinatarioVO";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { ContattoVO } from "@app/shared/vo/contattoVO";
import { Subscription } from "rxjs";
import { AnagrafeSseventsService } from "@app/shared/services/anagrafe-ssevents.service";
import { EnumValues } from "enum-values";
import { TipoRecapitoDigitaleEnum } from "@app/shared/enum/tipo-recapito-digitale-enum";
import { TipoRecapitoCartaceoEnum } from "@app/shared/enum/tipo-recapito-cartaceo-enum";
import { ModaleProvvisoriComponent } from "@app/utility/components/modale-provvisori/modale-provvisori.component";
import { ListaDistribuzioneAnagrafeVO } from "@app/shared/vo/gescor/lista-distribuzione-anagrafeVO";
import { AnagrafeService } from "@app/shared/services/anagrafe.service";
import { RecapitoVO } from "@app/shared/vo/gescor/recapitoVO";
import { ModaleRicercaListeDistribuzioneComponent } from "../modale-ricerca-liste-distribuzione/modale-ricerca-liste-distribuzione.component";
import { ModaleSoggettiAlternativiComponent } from "@app/utility/components/modale-soggetti-alternativi/modale-soggetti-alternativi.component";
import { ModaleDettaglioSoggettoRecapitoComponent } from "../modale-dettaglio-soggetto-recapito/modale-dettaglio-soggetto-recapito.component";
import { FiltroRicercaAnagrafeVO } from "@app/shared/vo/gescor/filtro-ricerca-anagrafeVO";
import { FiltroListaDistribuzioneVO } from "@app/shared/vo/gescor/filtro-lista-distribuzioneVO";
import { FiltroRecapitoAnagrafeVO } from "@app/shared/vo/gescor/filtro-recapito-anagrafeVO";
import { EventSourcePolyfill } from "event-source-polyfill";

@Component({
  selector: "app-tab-destinatari",
  templateUrl: "./tab-destinatari.component.html",
})
export class TabDestinatariComponent implements OnInit {
  public tabDestinatari;
  page = new PaginazioneVO();
  public tipoPartenza: TipoSupportoDocumentoEnum;
  public destinatarioSearch: string;
  messagesDest = {
    emptyMessage: "Nessun soggetto trovato",
    totalMessage: "in totale",
  };

  recapiti = new Array<string>(); // lista

  @ViewChild("modaleRicercaAvanzataAnagrafe", { static: false })
  public modaleRicercaAvanzataAnagrafe: ModaleRicercaAvanzataAnagrafeComponent;
  @ViewChild("modaleRicercaListeDistribuzione", { static: false })
  public modaleRicercaListeDistribuzione: ModaleRicercaListeDistribuzioneComponent;
  public rowsAnagrafe: EntitaAnagrafeVO[] = new Array<EntitaAnagrafeVO>();
  public rowsAlternativeAnagrafe: EntitaAnagrafeVO[] = new Array<
    EntitaAnagrafeVO
  >();
  public subscriptionRicercaAvanzataCart: Subscription;
  public subscriptionRicercaAvanzataDig: Subscription;
  public rowsAnagrafeProvvisori: EntitaAnagrafeVO[] = [];
  tipoRecapitoEnum: any;
  public rowsListe = new Array<ListaDistribuzioneAnagrafeVO>();
  public selected = [];
  listaContattiDiretti: ContattoVO[] = new Array<ContattoVO>();
  listaContattiConoscenza: ContattoVO[] = new Array<ContattoVO>();
  public subscriptionRicercaSempliceCart: Subscription;
  public subscriptionRicercaSempliceDig: Subscription;
  tipiRecapito: string;
  eventSourceAva: EventSourcePolyfill;
  eventSourceAvaDig: EventSourcePolyfill; esistonoProvvisori: boolean;
  public rowsAlternativaAnagrafe: EntitaAnagrafeVO[] = [];
  isCollapsedDestTableContent: boolean = false;
  isCollapsedDestListeTableContent: boolean = false;
  @ViewChild("appModaleProvvisori", { static: false })
  provvisoriModal: ModaleProvvisoriComponent;
  @ViewChild("modaleSoggettiAlternativi", { static: false })
  public soggettiAlternativiModal: ModaleSoggettiAlternativiComponent;
  @ViewChild("modaleSoggettiRecapito", { static: false })
  public soggettoRecapitoModal: ModaleDettaglioSoggettoRecapitoComponent;
  loadingIndicator: boolean;
  public filtroRicercaAnagrafeVO: FiltroRicercaAnagrafeVO;
  public filtroListaDistribuzioneVO: FiltroListaDistribuzioneVO;


  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private parentControl: ControlContainer,
    private anagrafeService: AnagrafeService,
    private anagrafeSseService: AnagrafeSseventsService
  ) { }

  ngOnInit() {
    this.tabDestinatari = this.parentControl.control.get("formDestinatari");
    console.log("this.tabDestinatari", this.tabDestinatari);
    this.page.pageNumber = 0;
    this.page.size = 3;
    this.rowsAlternativaAnagrafe = new Array<EntitaAnagrafeVO>();

  }

  cercaInAnagrafe() {
    this.tipoPartenza = this.parentControl.control.get(
      "formDestinatari.tipoPartenzaHidden"
    ).value;
    this.modaleRicercaAvanzataAnagrafe.openModal(this.tipoPartenza);
  }

  public ricercaSempliceAnagrafe() {
    console.log("ricercaSempliceAnagrafe");
    this.destinatarioSearch = this.parentControl.control.get(
      "formDestinatari.destinatarioSearch"
    ).value;
    this.rowsAnagrafe = [];
    this.rowsAlternativaAnagrafe = [];
    this.rowsListe = [];
    this.esistonoProvvisori = false;
    this.loadingIndicator = true;
    this.annullaRicerchePrecedenti();
    console.log("cercaInAnagrafe ", this.tipiRecapito);
    this.tipoPartenza = this.parentControl.control.get(
      "formDestinatari.tipoPartenzaHidden"
    ).value;
    if (this.destinatarioSearch != null && this.destinatarioSearch !== "") {
      let tipiRecapitoPerRicerca: string;
      if (this.tipoPartenza === TipoSupportoDocumentoEnum.CARTACEO) {
        tipiRecapitoPerRicerca = "CARTACEO";
      } else {
        tipiRecapitoPerRicerca = "PEC,APACI,MAIL";
      }
      this.subscriptionRicercaSempliceCart = this.anagrafeSseService
        .ricercaSempliceSSe(
          this.destinatarioSearch,
          tipiRecapitoPerRicerca,
          this.page,
          true
        )
        .subscribe(
          (data) => {
            console.log("data: ", data);
            if (data.statoSoggetto === "PROVVISORIO") {
              this.rowsAnagrafeProvvisori.push(data);
              this.rowsAnagrafeProvvisori = [...this.rowsAnagrafeProvvisori];
            } else {
              this.rowsAnagrafe.push(data);
              this.rowsAnagrafe = [...this.rowsAnagrafe];
            }
            if (this.rowsAnagrafeProvvisori.length > 0) {
              this.esistonoProvvisori = true;
            }
            this.cdRef.detectChanges();
          },
          (error) => console.log("errore durante ricerca: ", error),
          () => {
            console.log("completata ricerca ");
            this.loadingIndicator = false;
            this.cdRef.detectChanges();
          }
        );
      if (tipiRecapitoPerRicerca === "CARTACEO") {
        this.subscriptionRicercaSempliceDig = this.anagrafeSseService
          .ricercaSempliceSSe(
            this.destinatarioSearch,
            "PEC,APACI,MAIL",
            this.page,
            false
          )
          .subscribe(
            (data) => {
              const idSoggetti: string[] = this.rowsAnagrafe.map(
                (riga) => riga.idSoggetto
              );
              let isDataDaAggiungere: boolean = true;
              isDataDaAggiungere = !idSoggetti.includes(data.idSoggetto);
              const soggettiAlternativi = this.rowsAlternativaAnagrafe.filter(
                (riga) => !idSoggetti.includes(riga.idSoggetto)
              );
              console.log("isDataDaAggiungere :", soggettiAlternativi);
              console.log(
                "soggetti alternativi non esistenti di la :",
                soggettiAlternativi
              );
              this.rowsAlternativaAnagrafe = [];
              this.rowsAlternativaAnagrafe = [...soggettiAlternativi];
              if (isDataDaAggiungere) {
                this.rowsAlternativaAnagrafe.push(data);
              }
              this.cdRef.detectChanges();
            },
            (error) => {
              console.log("errore durante ricerca alternativa: ", error);
            },
            () => console.log("ricerca alternativa completata")
          );
      }
    } else {
      this.isCollapsedDestTableContent = false;
    }
  }

  public visualizzaSoggettiAlternativi() {
    this.soggettiAlternativiModal.openModal();
  }

  visualizzaSoggettiProvvisori() {
    this.provvisoriModal.openModal();
  }

  ricercaListe() {
    this.modaleRicercaListeDistribuzione.openModal();
  }

  public annullaRicerchePrecedenti() {
    if (
      this.subscriptionRicercaSempliceCart &&
      !this.subscriptionRicercaSempliceCart.closed
    ) {
      this.subscriptionRicercaSempliceCart.unsubscribe();
    }
    if (
      this.subscriptionRicercaSempliceDig &&
      !this.subscriptionRicercaSempliceDig.closed
    ) {
      this.subscriptionRicercaSempliceDig.unsubscribe();
    }
    if (
      this.subscriptionRicercaAvanzataCart &&
      !this.subscriptionRicercaAvanzataCart.closed
    ) {
      this.subscriptionRicercaAvanzataCart.unsubscribe();
    }
    if (
      this.subscriptionRicercaAvanzataDig &&
      !this.subscriptionRicercaAvanzataDig.closed
    ) {
      this.subscriptionRicercaAvanzataDig.unsubscribe();
    }
  }

  public isSelezionabile(row: EntitaAnagrafeVO): boolean {
    let isSelezionabile = true;
    if (
      row.listaSoggettiRecapito != null &&
      row.listaSoggettiRecapito.length > 0
    ) {
      row.listaSoggettiRecapito
        .filter(
          (soggetto) => soggetto.tipoSoggetto !== TipoSoggettoAnagrafeEnum.AOO
        )
        .filter((soggetto) => soggetto.idRecapito === row.idRecapito)
        .forEach((_) => (isSelezionabile = false));
    }
    return isSelezionabile;
  }

  public onSelectListe(lista: ListaDistribuzioneAnagrafeVO, tipo: string) {
    const destArray = this.tabDestinatari.controls["destinatari"] as FormArray;

    lista.recapiti.forEach((recapito) => {
      if (this.recapiti.indexOf(recapito) < 0) {
        this.anagrafeService.cercaRecapito(recapito).subscribe(
          (recapitoVO) => {
            if (
              !this.anagrafeSseService.isExcludedStr(
                recapitoVO.denominazioneRecapito
              )
            ) {
              const destinatarioVO = this.creaDestinatarioFromRecapito(
                recapitoVO,
                tipo
              );
              const dest = this.fb.group({
                tipoDestinatario: [destinatarioVO.tipoDestinatario],
                tipoSoggetto: [destinatarioVO.tipoSoggetto],
                recapitoVO: [destinatarioVO.recapitoVO],
                invio: [destinatarioVO.invio],
              });
              destArray.push(dest);
              this.creaContatto(destinatarioVO);
              this.recapiti.push(recapito); // ricerca del recapito già effettuata. Così non la rieseguo se sta uin due liste di distribuzione
            }
          },
          (err) => {
            console.log("errore : ", err);
            this.loadingIndicator = false;
          }
        );
      }
    });
  }

  public creaDestinatarioFromRecapito(
    recapitoVO: RecapitoVO,
    tipo: string
  ): DestinatarioVO {
    const destinatarioVO: DestinatarioVO = new DestinatarioVO();
    destinatarioVO.recapitoVO = new RecapitoVO();
    destinatarioVO.recapitoVO = recapitoVO;
    if (tipo === "DIRETTO") {
      destinatarioVO.tipoDestinatario = TipoDestinatarioEnum.DIRETTO.valueOf();
      destinatarioVO.recapitoVO.tipoRecapito = TipoDestinatarioEnum.DIRETTO;
    }
    if (tipo === "CONOSCENZA") {
      destinatarioVO.tipoDestinatario = TipoDestinatarioEnum.PER_CONOSCENZA.valueOf();
      destinatarioVO.recapitoVO.tipoRecapito =
        TipoDestinatarioEnum.PER_CONOSCENZA;
    }

    return destinatarioVO;
  }

  public onSelectRecapito(entitaAnagrafeVO: EntitaAnagrafeVO, tipo: string) {
    console.log("onSelectRecapito", entitaAnagrafeVO);
    if (this.recapiti.indexOf(entitaAnagrafeVO.idRecapito) < 0) {
      const destinatarioVO = this.creaDestinatarioFromEntitaAnagrafe(
        entitaAnagrafeVO,
        tipo
      );
      const destArray = this.tabDestinatari.controls[
        "destinatari"
      ] as FormArray;
      const dest = this.fb.group({
        tipoDestinatario: [destinatarioVO.tipoDestinatario],
        tipoSoggetto: [destinatarioVO.tipoSoggetto],
        recapitoVO: [destinatarioVO.recapitoVO],
        invio: [destinatarioVO.invio],
      });
      destArray.push(dest);
      this.recapiti.push(entitaAnagrafeVO.idRecapito);
      this.creaContatto(destinatarioVO);
    }
  }

  creaDestinatarioFromEntitaAnagrafe(
    entitaAnagrafeVO: EntitaAnagrafeVO,
    tipo: string
  ): DestinatarioVO {
    const destinatarioVO: DestinatarioVO = new DestinatarioVO();
    destinatarioVO.recapitoVO.denominazioneSoggetto =
      entitaAnagrafeVO.denominazioneSoggetto;
    if (
      (entitaAnagrafeVO.tipoSoggetto === TipoSoggettoAnagrafeEnum.UFFICIO ||
        entitaAnagrafeVO.tipoSoggetto === TipoSoggettoAnagrafeEnum.AOO) &&
      entitaAnagrafeVO.soggettoPadre
    ) {
      destinatarioVO.recapitoVO.denominazioneSoggetto =
        destinatarioVO.recapitoVO.denominazioneSoggetto +
        " - " +
        entitaAnagrafeVO.soggettoPadre.denominazioneSoggetto;
    }

    destinatarioVO.recapitoVO.denominazioneRecapito =
      entitaAnagrafeVO.denominazioneRecapito;
    destinatarioVO.recapitoVO.idRecapito = entitaAnagrafeVO.idRecapito;
    destinatarioVO.recapitoVO.idSoggetto = entitaAnagrafeVO.idSoggetto;
    destinatarioVO.tipoSoggetto = entitaAnagrafeVO.tipoSoggetto;
    destinatarioVO.recapitoVO.tipo = entitaAnagrafeVO.tipoRecapito;

    if (tipo === "DIRETTO") {
      destinatarioVO.tipoDestinatario = TipoDestinatarioEnum.DIRETTO.valueOf();
      destinatarioVO.recapitoVO.tipoRecapito = TipoDestinatarioEnum.DIRETTO;
    }
    if (tipo === "CONOSCENZA" || tipo === "PER_CONOSCENZA") {
      destinatarioVO.tipoDestinatario = TipoDestinatarioEnum.PER_CONOSCENZA.valueOf();
      destinatarioVO.recapitoVO.tipoRecapito =
        TipoDestinatarioEnum.PER_CONOSCENZA;
    }
    return destinatarioVO;
  }

  creaContatto(destinatarioVO: DestinatarioVO) {
    const contattoVO = new ContattoVO();
    contattoVO.idRecapito = destinatarioVO.recapitoVO.idRecapito;
    contattoVO.idSoggetto = destinatarioVO.recapitoVO.idSoggetto;
    contattoVO.nome = destinatarioVO.recapitoVO.denominazioneSoggetto;
    if (destinatarioVO.recapitoVO.tipoRecapito != null) {
      contattoVO.indirizzo = destinatarioVO.recapitoVO.tipoRecapito.toString();
    } else if (destinatarioVO.recapitoVO.tipo != null) {
      contattoVO.indirizzo = destinatarioVO.recapitoVO.tipo.toString();
    }
    let tipoSoggetto: string;
    if (destinatarioVO.tipoSoggetto === undefined) {
      tipoSoggetto = destinatarioVO.recapitoVO.tipoSoggetto;
    } else {
      tipoSoggetto = destinatarioVO.tipoSoggetto.toString();
    }
    switch (tipoSoggetto) {
      case TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE.toString():
        contattoVO.immagine = "./assets/img/amm.gif";
        break;
      case TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE_NON_IPA.toString():
        contattoVO.immagine = "./assets/img/amm.gif";
        break;
      case TipoSoggettoAnagrafeEnum.AOO.toString():
        contattoVO.immagine = "./assets/img/aoo.png";
        break;

      case TipoSoggettoAnagrafeEnum.ASSOCIAZIONE.toString():
        contattoVO.immagine = "./assets/img/ass.png";
        break;

      case TipoSoggettoAnagrafeEnum.CITTADINO.toString():
        contattoVO.immagine = "./assets/img/sogg.png";
        break;

      case TipoSoggettoAnagrafeEnum.IMPRESA.toString():
        contattoVO.immagine = "./assets/img/impr.png";
        break;

      case TipoSoggettoAnagrafeEnum.SOGGETTO_STRANIERO.toString():
        contattoVO.immagine = "./assets/img/soggstran.png";
        break;

      case TipoSoggettoAnagrafeEnum.UFFICIO.toString():
        contattoVO.immagine = "./assets/img/uo.png";
        break;
    }
    if (destinatarioVO.tipoDestinatario === TipoDestinatarioEnum.DIRETTO) {
      this.listaContattiDiretti.push(contattoVO);
    } else {
      this.listaContattiConoscenza.push(contattoVO);
    }
  }

  public spostaAltroLivello(
    destinatarioDaSpostare: ContattoVO[],
    tipo: string
  ) {
    let listaDestinatariPartenza = new Array<ContattoVO>();
    let listaDestinatariArrivo = new Array<ContattoVO>();
    let nuovoLivello: TipoDestinatarioEnum;

    if (tipo === "DIRETTO") {
      nuovoLivello = TipoDestinatarioEnum.PER_CONOSCENZA;
      listaDestinatariPartenza = this.listaContattiDiretti;
      listaDestinatariArrivo = this.listaContattiConoscenza;
      destinatarioDaSpostare[0].indirizzo = "PER_CONOSCENZA";
    } else {
      nuovoLivello = TipoDestinatarioEnum.DIRETTO;
      listaDestinatariPartenza = this.listaContattiConoscenza;
      listaDestinatariArrivo = this.listaContattiDiretti;
      destinatarioDaSpostare[0].indirizzo = "DIRETTO";
    }

    listaDestinatariPartenza = listaDestinatariPartenza.filter(
      (item) => item.idRecapito !== destinatarioDaSpostare[0].idRecapito
    );

    listaDestinatariArrivo.push(destinatarioDaSpostare[0]);

    if (tipo === "DIRETTO") {
      this.listaContattiDiretti = listaDestinatariPartenza;
      this.listaContattiConoscenza = listaDestinatariArrivo;
    } else {
      this.listaContattiConoscenza = listaDestinatariPartenza;
      this.listaContattiDiretti = listaDestinatariArrivo;
    }

    const destArray = this.tabDestinatari.controls["destinatari"] as FormArray;
    let indiceDaAgg: number;
    for (let i = 0; i < destArray.length; i++) {
      if (
        destArray.at(i).get("recapitoVO").value.idRecapito ===
        destinatarioDaSpostare[0].idRecapito
      ) {
        indiceDaAgg = i;
      }
    }
    let destDaAggiornare = new DestinatarioVO();
    destDaAggiornare = destArray.at(indiceDaAgg).value;
    destDaAggiornare.tipoDestinatario = nuovoLivello;

    destArray.at(indiceDaAgg).patchValue(destDaAggiornare);
  }

  public filtraIdSoggettoIdRecapito(
    destinatario: DestinatarioVO,
    contatto: ContattoVO
  ): boolean {
    return (
      destinatario.recapitoVO.idSoggetto !== contatto.idSoggetto ||
      destinatario.recapitoVO.idRecapito !== contatto.idRecapito
    );
  }

  public aggiornaDopoRimozione(
    listaDestinatariNew: ContattoVO[],
    competenza: string
  ) {
    let listaDestinatariOld = new Array<ContattoVO>();
    if (competenza === "DIRETTO") {
      listaDestinatariOld = this.listaContattiDiretti;
    } else {
      listaDestinatariOld = this.listaContattiConoscenza;
    }

    const missingDestinatario = listaDestinatariOld.filter(
      (item) => listaDestinatariNew.indexOf(item) < 0
    );

    console.log("missingDestinatario", missingDestinatario[0].idRecapito);

    if (missingDestinatario.length > 0) {
      listaDestinatariOld = listaDestinatariOld.filter(
        (item) => missingDestinatario[0].idSoggetto !== item.idSoggetto
      );
      this.recapiti = this.recapiti.filter(
        (item) => missingDestinatario[0].idRecapito !== item
      );
    }
    if (competenza === "DIRETTO") {
      this.listaContattiDiretti = listaDestinatariNew;
    } else {
      this.listaContattiConoscenza = listaDestinatariNew;
    }
    const destArray = this.tabDestinatari.controls["destinatari"] as FormArray;
    console.log("missingDestinatario index", destArray.value.findIndex(
      (destinatario) =>
        destinatario.recapitoVO.idRecapito === missingDestinatario[0].idRecapito
    ));
    destArray.removeAt(
      destArray.value.findIndex(
        (destinatario) =>
          destinatario.recapitoVO.idRecapito === missingDestinatario[0].idRecapito
      )
    );
  }

  public dettaglio(riga: EntitaAnagrafeVO) {
    this.soggettoRecapitoModal.openModal(riga);
  }




  ricercaAvanzataInAnagrafe() {
    console.log("ricercaAvanzataInAnagrafe", this.filtroRicercaAnagrafeVO);
    this.rowsAlternativaAnagrafe = new Array<EntitaAnagrafeVO>();
    this.rowsListe = [];
    this.esistonoProvvisori = false;
    this.loadingIndicator = true;
    this.isCollapsedDestTableContent = true;
    this.isCollapsedDestListeTableContent = false;
    this.rowsAnagrafe = new Array<EntitaAnagrafeVO>();
    this.annullaRicerchePrecedenti();
    this.filtroRicercaAnagrafeVO.paginazione = this.page;
    this.tipoPartenza = this.parentControl.control.get(
      "formDestinatari.tipoPartenzaHidden"
    ).value;

    if (this.tipoPartenza === TipoSupportoDocumentoEnum.DIGITALE) {
      this.tipoRecapitoEnum = TipoRecapitoDigitaleEnum;
    } else {
      this.tipoRecapitoEnum = TipoRecapitoCartaceoEnum;
    }
    EnumValues.getNames(this.tipoRecapitoEnum).forEach((value) => {
      if (value === "PEC" || value === "APACI") {
        this.tipiRecapito = "PEC,APACI,MAIL";
      }
      if (value === "CARTACEO") {
        this.tipiRecapito = "CARTACEO";
      }
    });
    this.eventSourceAva = this.anagrafeSseService.creaRicercaAvanzataEstesa(
      this.filtroRicercaAnagrafeVO,
      this.tipiRecapito,
      this.page,
      false
    );


    this.subscriptionRicercaAvanzataCart = this.anagrafeSseService
      .ricercaAvanzataEstesa(
        this.eventSourceAva
      )
      .subscribe(
        (data) => {
          console.log("data: ", data);
          this.rowsAnagrafe.push(data);
          this.rowsAnagrafe = [...this.rowsAnagrafe];
          this.cdRef.detectChanges();
          console.log("emitAnagrafe", this.rowsAnagrafe);
        },
        (error) => console.log("errore durante ricerca: ", error),
        () => {
          console.log("completata ricerca ");
          this.loadingIndicator = false;
          this.cdRef.detectChanges();
        }
      );

    if (this.tipiRecapito === "CARTACEO") {
      let tipi: string;

      tipi = "PEC,APACI,MAIL";

      this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO = new FiltroRecapitoAnagrafeVO();
      this.eventSourceAvaDig = this.anagrafeSseService.creaRicercaAvanzataEstesa(
        this.filtroRicercaAnagrafeVO,
        tipi,
        this.page,
        false
      );
      this.subscriptionRicercaAvanzataDig = this.anagrafeSseService
        .ricercaAvanzataEstesa(this.eventSourceAvaDig)
        .subscribe(
          (data) => {
            console.log("data2: ", data);
            const idSoggetti: string[] = this.rowsAnagrafe.map(
              (riga) => riga.idSoggetto
            );
            let isDataDaAggiungere: boolean = true;
            isDataDaAggiungere = !idSoggetti.includes(data.idSoggetto);
            const soggettiAlternativi = this.rowsAlternativaAnagrafe.filter(
              (riga) => !idSoggetti.includes(riga.idSoggetto)
            );
            console.log("isDataDaAggiungere :", soggettiAlternativi);
            console.log(
              "soggetti alternativi non esistenti di la :",
              soggettiAlternativi
            );
            this.rowsAlternativaAnagrafe = [];
            this.rowsAlternativaAnagrafe = [...soggettiAlternativi];
            if (isDataDaAggiungere) {
              this.rowsAlternativaAnagrafe.push(data);
            }
            this.cdRef.detectChanges();
          },
          (error) => console.log("errore durante ricerca: ", error),
          () => {
            console.log("completata ricerca ");
            this.loadingIndicator = false;
            this.cdRef.detectChanges();
          }
        );
    }
  }

  public ricercaListeDistribuzione() {
    this.rowsAnagrafe = [];
    this.esistonoProvvisori = false;
    this.rowsAlternativaAnagrafe = [];
    this.isCollapsedDestTableContent = false;
    this.isCollapsedDestListeTableContent = true;
    this.loadingIndicator = true;
    this.rowsListe = new Array<ListaDistribuzioneAnagrafeVO>();
    console.log("ricercaListeDistribuzione: ", this.filtroListaDistribuzioneVO);
    this.anagrafeService
      .ricercaListeDistribuzione(this.filtroListaDistribuzioneVO)
      .subscribe(
        (res) => {
          this.rowsListe = res;
          console.log("risultato liste", this.rowsListe);
          this.loadingIndicator = false;
        },
        (_) => {
          this.loadingIndicator = false;
        }
      );

  }
}
